import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import followUpModalReducer from '../reducers/followUpModalReducer';

const configureStore = (railsProps) => (
  createStore(followUpModalReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
